// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"f1da5761","517":"a707108f"}[chunkId] + ".chunk.js";
};